export const ADMIN_ROLE : string = "admin";
export const TRAINER_ROLE : string = "trainer";
export const SEPA_DEBIT = "sepa_debit";
export const CARD = "Card";